import React from "react";

interface AiSparkleIconProps {
  size?: number;
  className?: string;
}

// Four-point "sparkle" glyph used to mark every AI affordance on the board. Inline SVG drawn with
// currentColor so it inherits the host button's text color and stays crisp at any size — matches
// the comment composer's inline toolbar icons (no emoji, no sprite dependency).
const AiSparkleIcon: React.FC<AiSparkleIconProps> = ({ size = 14, className }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true" className={className}>
    <path d="M8 1.5l1.45 3.85L13.3 6.8 9.45 8.25 8 12.1 6.55 8.25 2.7 6.8l3.85-1.45L8 1.5z" fill="currentColor" />
    <path d="M12.9 9.9l.55 1.5 1.5.55-1.5.55-.55 1.5-.55-1.5-1.5-.55 1.5-.55.55-1.5z" fill="currentColor" />
  </svg>
);

export default AiSparkleIcon;
